// extracted by mini-css-extract-plugin
export default {"item":"EmojiAutocompleter-module__item--1+zqk"};